import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

/**
 * SessionTimeoutWarningComponent
 *
 * Modal dialog that warns users of imminent session timeout due to inactivity.
 * Displays a countdown and allows users to continue their session.
 *
 * Phase 5: Session Timeout Implementation
 */
@Component({
  selector: 'app-session-timeout-warning',
  templateUrl: './session-timeout-warning.component.html',
  styleUrls: ['./session-timeout-warning.component.scss'],
  standalone: false
})
export class SessionTimeoutWarningComponent implements OnInit, OnDestroy {
  countdown: number = 60; // 1 minute countdown in seconds
  private countdownInterval: any;

  constructor(public dialogRef: MatDialogRef<SessionTimeoutWarningComponent>) {
    // Prevent closing modal by clicking outside
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    // Start countdown
    this.startCountdown();
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  /**
   * Start countdown timer
   */
  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.clearCountdown();
        // Auto-close dialog and trigger logout
        this.dialogRef.close('timeout');
      }
    }, 1000);
  }

  /**
   * Clear countdown timer
   */
  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  /**
   * User clicked "Continue Session" button
   */
  continueSession(): void {
    this.clearCountdown();
    this.dialogRef.close('continue');
  }

  /**
   * Format countdown for display (MM:SS)
   */
  get formattedCountdown(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
